module.exports = "/_next/static/images/85c73bd6527dde2be818e9fdce716e92-rewards-hosting@1x.png";